<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="91"
        height="20"
        viewBox="0 0 91 20"
        fill="none"
    >
        <path
            d="M14.2231 20C14.2231 20 23.1437 20 25.3564 19.4C26.6023 19.06 27.5393 18.08 27.8681 16.87C28.4761 14.65 28.4761 9.98 28.4761 9.98C28.4761 9.98 28.4761 5.34 27.8681 3.14C27.5393 1.9 26.6023 0.94 25.3564 0.61C23.1437 0 14.2231 0 14.2231 0C14.2231 0 5.32245 0 3.11972 0.61C1.89376 0.94 0.936912 1.9 0.588062 3.14C0 5.34 0 9.98 0 9.98C0 9.98 0 14.65 0.588062 16.87C0.936912 18.08 1.89376 19.06 3.11972 19.4C5.32245 20 14.2231 20 14.2231 20Z"
            fill="#FF0033"
        />
        <path d="M18.6568 10L11.2922 5.75V14.25L18.6568 10Z" fill="white" />
        <path
            d="M36.4677 18.9015V13.4415L39.875 2.10156H37.3318L36.0357 7.25156C35.7411 8.43156 35.476 9.66156 35.2796 10.8015H35.1225C35.0145 9.80156 34.7002 8.49156 34.386 7.23156L33.1292 2.10156H30.5859L33.9442 13.4415V18.9015H36.4677Z"
            fill="black"
        />
        <path
            d="M43.3038 6.30127C40.3286 6.30127 39.3074 8.05127 39.3074 11.8212V13.6112C39.3074 16.9912 39.9456 19.1112 43.2449 19.1112C46.4951 19.1112 47.1923 17.0912 47.1923 13.6112V11.8212C47.1923 8.45127 46.5246 6.30127 43.3038 6.30127ZM44.5705 14.7212C44.5705 16.3612 44.2858 17.3912 43.2548 17.3912C42.2434 17.3912 41.9586 16.3512 41.9586 14.7212V10.6812C41.9586 9.28127 42.155 8.03127 43.2548 8.03127C44.4134 8.03127 44.5705 9.35127 44.5705 10.6812V14.7212Z"
            fill="black"
        />
        <path
            d="M51.3273 19.0915C52.7609 19.0915 53.6545 18.4815 54.391 17.3815H54.499L54.607 18.9015H56.5609V6.5415H53.9687V16.4715C53.6937 16.9615 53.0554 17.3215 52.4564 17.3215C51.7004 17.3215 51.4648 16.7115 51.4648 15.6915V6.5415H48.8822V15.8115C48.8822 17.8215 49.4518 19.0915 51.3273 19.0915Z"
            fill="black"
        />
        <path
            d="M61.6914 18.9015V4.15156H64.6764V2.10156H56.1434V4.15156H59.1285V18.9015H61.6914Z"
            fill="black"
        />
        <path
            d="M66.6469 19.0915C68.0806 19.0915 68.9741 18.4815 69.7106 17.3815H69.8186L69.9266 18.9015H71.8806V6.5415H69.2883V16.4715C69.0134 16.9615 68.3751 17.3215 67.7761 17.3215C67.0201 17.3215 66.7844 16.7115 66.7844 15.6915V6.5415H64.2019V15.8115C64.2019 17.8215 64.7714 19.0915 66.6469 19.0915Z"
            fill="black"
        />
        <path
            d="M79.2173 6.27141C77.9604 6.27141 77.057 6.83141 76.458 7.74141H76.3304C76.4089 6.54141 76.4679 5.52141 76.4679 4.71141V1.44141H73.9639L73.9541 12.1814L73.9639 18.9014H76.1438L76.3304 17.7014H76.3991C76.9785 18.5114 77.872 19.0214 79.0602 19.0214C81.0339 19.0214 81.8783 17.2914 81.8783 13.6114V11.7014C81.8783 8.26141 81.4954 6.27141 79.2173 6.27141ZM79.3056 13.6114C79.3056 15.9114 78.9718 17.2814 77.9211 17.2814C77.4302 17.2814 76.7526 17.0414 76.4482 16.5914V9.24141C76.7133 8.54141 77.3025 8.03141 77.9604 8.03141C79.0209 8.03141 79.3056 9.34141 79.3056 11.7314V13.6114Z"
            fill="black"
        />
        <path
            d="M90.9783 11.5015C90.9783 8.52152 90.6837 6.31152 87.3157 6.31152C84.144 6.31152 83.437 8.46152 83.437 11.6215V13.7915C83.437 16.8715 84.0851 19.1115 87.2371 19.1115C89.7312 19.1115 91.0176 17.8415 90.8703 15.3815L88.6609 15.2615C88.6315 16.7815 88.2878 17.4015 87.296 17.4015C86.049 17.4015 85.99 16.1915 85.99 14.3915V13.5515H90.9783V11.5015ZM87.2567 7.97152C88.4547 7.97152 88.5431 9.12152 88.5431 11.0715V12.0815H85.99V11.0715C85.99 9.14152 86.0686 7.97152 87.2567 7.97152Z"
            fill="black"
        />
    </svg>
</template>

<script>
export default {
    name: 'Youtube'
};
</script>
